<!--
 * @Author: aisi
 * @Date: 2020-01-04 09:44:40
 * @LastEditTime : 2020-01-07 17:36:24
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /vue/wei/src/views/analyseWord/studySurvey/CourseAverage.vue
-->
<template>
  <div class="bar">
    <div :id="id" style="height:350px"></div>
  </div>
</template>
<script>
// 引入 ECharts 主模块
const echarts = require('echarts/lib/echarts')
// 引入柱状图
require('echarts/lib/chart/bar')
// 引入图例
require('echarts/lib/component/legend')
// 引入图表标线
require('echarts/lib/component/markLine')
export default {
  props: [
    'id',
    'color',
    'data',
    'ydata',
    'seriesData',
    'legendData',
    'yname',
    'yunit'
  ],
  mounted() {
    let dom = echarts.init(document.getElementById(this.id), null, {
      renderer: 'svg'
    })
    let series = [],
      xAxis,
      yAxis
    // 多柱条
    if (this.legendData) {
      this.legendData.forEach((item, key) => {
        let obj = {}
        if (this.ydata) {
          obj = {
            name: item,
            type: 'bar',
            stack: '总量',
            label: {
              show: true,
              position: 'insideRight'
            },
            data: this.seriesData[key]
          }
        } else {
          obj = {
            name: item,
            data: this.seriesData[key],
            type: 'bar',
            barMaxWidth: 40,
            label: {
              show: true,
              position: 'top'
            }
          }
        }
        series.push(obj)
      })
    } else {
      let obj = {
        data: this.seriesData,
        type: 'bar',
        barMaxWidth: 40,
        markLine: {
          data: [{ type: 'average', name: '平均值' }]
        },
        label: {
          show: true,
          position: 'top'
        }
      }
      series.push(obj)
    }
    if (this.data) {
      xAxis = {
        type: 'category',
        data: this.data
      }
      yAxis = {
        type: 'value',
        name: this.yname,
        min: function(value) {
          return Math.round(value.min - 3)
        },
        axisLabel: {
          formatter: '{value} ' + this.yunit
        }
      }
    } else {
      xAxis = {
        type: 'value',
        name: this.yname
      }
      yAxis = {
        type: 'category',
        data: this.ydata
      }
    }
    dom.setOption({
      color: this.color,
      legend: {
        data: this.legendDate
      },
      xAxis: xAxis,
      yAxis: yAxis,
      series: series
    })
  }
}
</script>
<style lang="scss" scoped></style>
